import { Button } from "@/components/ui/button"
import { Card, CardContent } from "@/components/ui/card"
import { VALIDATION_ERROR_KEYS } from "@/i18n"
import { FormRenderer } from "@/lib/data-driven-forms/renderer"
import { DataDrivenFormSchema } from "@/lib/data-driven-forms/schema"
import { useId } from "react"
import { useTranslation } from "react-i18next"
import * as z from "zod"
import logo from "/images/Full Logotype.svg"
import { useNavigate, useProps } from "@/lib/page-rendering"

const formSchema: DataDrivenFormSchema<"users"> = {
  type: "form",
  validator: z
    .object({
      password: z
        .string()
        .trim()
        .min(1, VALIDATION_ERROR_KEYS.REQUIRED)
        .min(6, "users:form.errors.password_minimum"),
      password_confirmation: z
        .string()
        .trim()
        .min(1, VALIDATION_ERROR_KEYS.REQUIRED)
        .min(6, "users:form.errors.password_minimum"),
    })
    .refine((data) => data.password === data.password_confirmation, {
      message: "users:form.errors.password_mismatch",
      path: ["password_confirmation"],
    }),
  namespace: "users",
  properties: [
    {
      type: "field:input",
      name: "password",
      label: "form.password.new_password",
      inputType: "password",
    },
    {
      type: "field:input",
      name: "password_confirmation",
      label: "form.password.new_password_confirmation",
      inputType: "password",
    },
  ],
}

export default function Page() {
  const navigate = useNavigate()
  const { reset_password_token } = useProps<{
    reset_password_token: string
  }>()
  const { t } = useTranslation("users", { keyPrefix: "form.reset_password" })
  const formId = useId()
  return (
    <>
      <Card className="m-8 max-w-md min-w-96 self-center p-8">
        <CardContent>
          <div className="mb-8 flex flex-row items-center justify-center">
            <img src={logo} alt="Sagecool Logo" className="h-22.5" />
          </div>
          <FormRenderer
            formId={formId}
            schema={formSchema}
            defaultValues={{}}
            onSubmit={(data) =>
              navigate({
                href: "/users/password",
                method: "patch",
                data: {
                  user: {
                    ...data,
                    reset_password_token,
                  },
                },
              })
            }
          />
          <Button form={formId} className="mt-4 w-full">
            {t("action")}
          </Button>
        </CardContent>
      </Card>
    </>
  )
}
